// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609300310/js/" + chunkId + "." + {"44":"712f6912","225":"4ea6f42c","481":"92b74385","486":"50e88065","770":"9aefc94a"}[chunkId] + ".0.8694086512804322.chunk.js";
};